import Card from '../../components/Card';
import React from 'react';
import { useT } from '../../utils/useTranslation';
import heroBg from '../../assets/sas_hero_new.png';
import ajrakTexture from '../../assets/ajrak_texture_new.jpg';
import { motion } from 'framer-motion';
import HeroBackground from '../../components/ui/HeroBackground';

export default function AboutPage() {
  const t = useT();
  return (
    <>
      <div className="hero-premium">
        <HeroBackground />
        <div style={{ position: 'relative', zIndex: 10 }}>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 48,
              fontWeight: 800,
              color: 'var(--sindhi-gold)',
              marginBottom: 16,
              letterSpacing: -1,
            }}
          >
            {t('aboutTitle')}
          </motion.h1>
          <p
            style={{
              opacity: 0.8,
              fontSize: 18,
              maxWidth: 700,
              margin: '0 auto',
              fontWeight: 500,
            }}
          >
            {t('aboutDesc')}
          </p>
        </div>
      </div>

      <div
        style={{
          background: 'var(--sindhi-ivory)',
          backgroundImage: `url(${ajrakTexture})`,
          backgroundSize: '600px 600px',
          backgroundRepeat: 'repeat',
          position: 'relative',
          zIndex: 10,
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backdropFilter: 'blur(3px)',
            WebkitBackdropFilter: 'blur(3px)',
            background: 'rgba(253,248,235,0.7)',
            zIndex: 0,
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            maxWidth: 1000,
            margin: '0 auto',
            padding: '64px 24px 100px',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
              gap: 24,
            }}
          >
            {[{
              title: t('ourHistory'),
              icon: '🏛️',
              content: t('ourHistoryDesc'),
              color: 'var(--sindhi-maroon)',
            }, {
              title: t('ourMission'),
              icon: '🎯',
              content: t('ourMissionDesc'),
              color: 'var(--sindhi-gold)',
            }, {
              title: t('ourVision'),
              icon: '🌟',
              content: t('ourVisionDesc'),
              color: '#3498db',
            }, {
              title: t('ourAchievements'),
              icon: '🏆',
              content: t('ourAchievementsDesc'),
              color: '#2ecc71',
            }].map((s, i) => (
              <Card key={i} style={{ padding: 40, background: 'white' }}>
                <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start' }}>
                  <div
                    style={{
                      fontSize: 32,
                      width: 64,
                      height: 64,
                      borderRadius: 16,
                      background: `${s.color}15`,
                      color: s.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}
                  >
                    {s.icon}
                  </div>
                  <div>
                    <h2
                      style={{
                        fontFamily: 'var(--font-display)',
                        fontSize: 22,
                        fontWeight: 800,
                        color: 'var(--sindhi-navy)',
                        marginBottom: 14,
                      }}
                    >
                      {s.title}
                    </h2>
                    <p
                      style={{
                        color: 'var(--sindhi-text-muted)',
                        lineHeight: 1.8,
                        fontSize: 15,
                      }}
                    >
                      {s.content}
                    </p>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
